import { render, staticRenderFns } from "./UserChat.vue?vue&type=template&id=d132105a&"
import script from "./UserChat.vue?vue&type=script&lang=js&"
export * from "./UserChat.vue?vue&type=script&lang=js&"
import style0 from "./UserChat.vue?vue&type=style&index=0&id=d132105a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports